module.exports = __webpack_public_path__ + "img/DE02076.610d8c91.png";